import config from '../config';
import React, { useState, useEffect } from 'react';
import '../style/Login.css';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/authContext';
import { ClipLoader } from 'react-spinners';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login } = useAuth();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'BackpackEMR WebAdmin';
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setButtonClicked(true);

    if (!email || !password) {
      setError('Please fill in all fields');
      setButtonClicked(false);
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await fetch(`${config.BASE_URL}/members/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Invalid username or password');
      }

      const authResult = await response.json();

      const userResponse = await fetch(
        `${config.BASE_URL}/members/email/${email}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${authResult.authResult.AccessToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (!userResponse.ok) {
        throw new Error('Invalid username or password');
      }

      const userData = await userResponse.json();

      if (!Array.isArray(userData) || userData.length === 0) {
        throw new Error('Invalid username or password');
      }

      const userDetails = userData[0];
//verify is active
 if (!userDetails.isActive) {
        throw new Error('Invalid username or password');
      }
      // Verify web access again 
      if (!userDetails.hasWebAccess) {
        throw new Error('Invalid username or password');
      }

      // Fetch organization details
      const orgResponse = await fetch(
        `${config.BASE_URL}/organizations/${userDetails.OrganizationId}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${authResult.authResult.AccessToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (!orgResponse.ok) {
        throw new Error('Invalid username or password');
      }

      const orgData = await orgResponse.json();

      // Call the login function from authContext to store user data
      login(authResult.authResult, userDetails);

      // Simplified navigation logic
      if (userDetails.backpackEMRRole === 'SUPERADMIN') {
        navigate('/organizations');
      } else if (userDetails.OrganizationId) {
        navigate(`/organization/${userDetails.OrganizationId}`);
      } else {
        throw new Error('Invalid username or password');
      }
    } catch (err) {
      setError(err.message);
      setButtonClicked(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      {loading && (
        <div className="loader-overlay">
          <ClipLoader color="#006d7d" size={50} />
        </div>
      )}
      <form className="login-form" onSubmit={handleLogin}>
        <h2>Login</h2>
        <hr className="divider" />

        <div className="input-group">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            required
          />
        </div>

        <div className="input-group">
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            required
          />
        </div>

        {error && <div className="error-message">{error}</div>}

        <button
          type="submit"
          className={`login-button ${buttonClicked ? 'clicked' : ''}`}
          disabled={loading}
        >
          Log In
        </button>
      </form>
    </div>
  );
};

export default Login;